import { RemoteHandleActivitiesSummarizedByStudent } from 'data/usecases';
import { HandleActivitiesSummarizedByStudentUseCaseInterface } from 'domain/usecases';
import { makeApiUrlActivitiesSummarizedByStudent } from 'main/factories/http/api-url-factory';
import { makeAxiosHttpClient } from 'main/factories/http/axios-http-client-factory';

export const makeHandleActivitiesSummarizedByStudent =
  (): HandleActivitiesSummarizedByStudentUseCaseInterface =>
    new RemoteHandleActivitiesSummarizedByStudent(
      makeApiUrlActivitiesSummarizedByStudent(),
      makeAxiosHttpClient(),
    );
